import React from "react";
import Connect from "./Connect";

export default function Header() {
  return (
    <React.Fragment>
      <header id="header">
        <Connect />
      </header>
    </React.Fragment>
  );
}
